import React from 'react'
import { useTranslation } from 'react-i18next'
import { MegaTagTitle } from '@/components/Elements'
import { ConstructorContainer } from '@/features/constructor/components/Constructor'

export const Pane = () => {
  const { t } = useTranslation()

  return (
    <>
      <MegaTagTitle title={'edit_facade.application_pane.title'} />

      <ConstructorContainer />
    </>
  )
}
